export enum LogFormat {
  JSON = 'json',
  PLAINTEXT = 'plaintext',
}
